import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TipoCliente} from '@/model/resource/TipoCliente'

@HttpExclude()
export class TipoClienteCollection extends PageCollection<TipoCliente> {
  constructor() {
    super(TipoCliente)
  }

  queryAsPage() {
    return this.listTipoCliente()
  }

  /**
   * Returns all types on the database
   */
  async listTipoCliente() {
    return await Request.get(`/admin/tipo-cliente`, {params: this.params})
      .name('listTipoCliente')
      .as(this)
      .getResponse()
  }
  static listTipoCliente(): TipoClienteCollection {
    const collection = new TipoClienteCollection()
    collection.items = [
      {
        idTipoClientePk: 1,
        nome: 'Cliente',
      },
      {
        idTipoClientePk: 2,
        nome: 'Parceiro',
      },
    ] as TipoCliente[]
    return collection
  }
}
